import { Individual, NotRegistered, Registered } from '~/apps/smartsend/lib/consts/TaxStatusConsts';
import { CustomerType } from './CustomerType';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import GetVatStatuses from './GetVatStatuses';
import { useTaxName } from '@parcel2go/npm-p2g-app';

const useVatStatuses = (translationNamespace: string) => {
  const { t } = useTranslation(translationNamespace);
  const taxName = useTaxName();

  const taxStatues = useMemo(() => {
    return [
      {
        value: Individual,
        text: t(`TAX_STATUS_INDIVIDUAL`, { defaultValue: 'Personal Individual', taxName: taxName })
      },
      {
        value: Registered,
        text: t(`TAX_STATUS_REGISTERED`, { defaultValue: `Company - {{taxName}} Registered`, taxName: taxName })
      },
      {
        value: NotRegistered,
        text: t(`TAX_STATUS_NOT_REGISTERED`, { defaultValue: `Company - Non {{taxName}} Registered`, taxName: taxName })
      }
    ];
  }, [t, taxName]);

  const getStatuses = useCallback(
    (customerType: CustomerType) => {
      const statuses = GetVatStatuses(customerType);
      return taxStatues.filter((x) => statuses.includes(x.value));
    },
    [taxStatues]
  );

  return { getStatuses } as const;
};

export default useVatStatuses;
